import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAdminSession, saveAdminSession } from "./adminApi";
import "./admin.css";

// Admin entry (replaces the PHP admin_trigger.php): the game login sends
// /admin?sessionId=..&userId=..&organizationId=..&gameId=.. and we keep it for the admin pages.
function Admin() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const sessionId = params.get("sessionId");
    const organizationId = params.get("organizationId");

    if (sessionId && organizationId) {
      saveAdminSession({
        sessionId,
        organizationId,
        userId: params.get("userId"),
        gameId: params.get("gameId"),
      });
      navigate("/admin/themes", { replace: true });
      return;
    }

    if (getAdminSession()) {
      navigate("/admin/themes", { replace: true });
      return;
    }

    // Fallback: a player session already stored by the login page
    try {
      const user = JSON.parse(sessionStorage.getItem("userData"));
      if (user?.sessionId && user?.organizationId) {
        saveAdminSession({
          sessionId: user.sessionId,
          organizationId: user.organizationId,
          userId: user.userId,
          gameId: user.gameId,
        });
        navigate("/admin/themes", { replace: true });
        return;
      }
    } catch {
      /* no stored session */
    }
    setMissing(true);
  }, [search, navigate]);

  if (!missing) return null;
  return (
    <div className="adm-page">
      <div className="adm-card adm-center">
        <h2>Admin session not found</h2>
        <p>Open the admin from the game platform, or sign in as superadmin.</p>
        <Link className="adm-btn" to="/admin/superadmin">Superadmin login</Link>
      </div>
    </div>
  );
}

export default Admin;
